import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../../common/components/Dialog";
import { StyledButton } from "../../../../common/components/Button";
import { StyledTextField } from "../../../../common/components/TextField/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import { serviceSchema } from "../../schemas/serviceSchema";
import { updateService } from "../../../../api/serviceApi";
import { Link } from "@mui/material";

import ImageDropzone from "./ImageDropzone";
const UpdateServiceDialog = ({
  openUpdateService,
  handleCloseUpdateService,
  currentService,
  fetchServices,
}) => {
  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors, isSubmitting },
    reset,
  } = useForm({
    resolver: yupResolver(serviceSchema),
  });

  useEffect(() => {
    let defaultValues = {};
    defaultValues.id = currentService.id;
    defaultValues.name = currentService.name;
    defaultValues.description = currentService.description;
    defaultValues.type = currentService.type;
    defaultValues.price = 0;
    defaultValues.imageUrl = currentService.imageUrl;
    defaultValues.sequence = currentService.sequence;

    reset({ ...defaultValues });
  }, [currentService, reset]);

  const getValue = function (o, s) {
    s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
    s = s.replace(/^\./, ""); // strip a leading dot
    var a = s.split(".");
    for (var i = 0, n = a.length; i < n; ++i) {
      var k = a[i];
      if (k in o) {
        o = o[k];
      } else {
        return;
      }
    }
    return o;
  };

  const handleDrop = (name, file) => {
    setValue(name, file, { shouldValidate: true, shouldTouch: true });
  };

  const submitUpdateService = async (values) => {
    if (values.imageFile != null) {
      values.imageFile = values.imageFile.file;
    }

    const formData = new FormData();
    for (var key in values) {
      formData.append(key, values[key]);
    }

    await updateService(formData);
    handleCloseUpdateService();
    fetchServices();
  };

  return (
    <div>
      <StyledDialog
        open={openUpdateService}
        onClose={handleCloseUpdateService}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle> Update Service</DialogTitle>
        <form onSubmit={handleSubmit(submitUpdateService)}>
          <DialogContent dividers>
            <Grid container direction="row">
              <Grid item xs={10}>
                <StyledTextField
                  variant="outlined"
                  label="Name"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.name}
                  helperText={errors.name?.message}
                  {...register("name")}
                  sx={{ width: "100%" }}
                />
              </Grid>

              <Grid item xs={10}>
                <StyledTextField
                  variant="outlined"
                  label="Description"
                  multiline
                  rows={3}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.description}
                  helperText={errors.description?.message}
                  {...register("description")}
                  sx={{ width: "100%" }}
                />
              </Grid>
              <ImageDropzone
                type={2}
                label={"Image"}
                name={"imageFile"}
                control={control}
                error={getValue(errors, "imageFile")}
                onDrop={(f) => {
                  handleDrop("imageFile", {
                    file: f,
                    type: 2,
                    subType: 1,
                  });
                }}
              />
              <Grid item xs={10}>
                {currentService.imageUrl !== null &&
                  currentService.imageUrl !== "" && (
                    <Link
                      href={currentService.imageUrl}
                      style={{ marginBottom: "10px" }}
                      target="_blank"
                    >
                      Download Current Image
                    </Link>
                  )}
              </Grid>
              <Grid item xs={10}>
                <StyledTextField
                  variant="outlined"
                  label="Sequence"
                  type="number"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.sequence}
                  helperText={errors.sequence?.message}
                  {...register("sequence")}
                  sx={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton
              theme="purple"
              type="button"
              onClick={handleCloseUpdateService}
            >
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit" disabled={isSubmitting}>
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default UpdateServiceDialog;
